// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3dt86","social":"footer-module--social--2raG-","mobile":"footer-module--mobile--3Jrom"};